import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { SearchHistory } from "@/components/SearchHistory";
import { SummaryHistory } from "@/components/SummaryHistory";
import { useAuth } from "@/hooks/useAuth";
import { useTutorial } from "@/hooks/useTutorial";
import { Helmet } from "react-helmet-async";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface SearchHistoryItem {
  id: string;
  collection_name: string;
  search_text: string;
  created_at: string;
  results: any;
}

const Historial = () => {
  const { user, loading } = useAuth();
  const { currentStep, completeStep } = useTutorial();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("searches");

  // Mark tutorial step as completed when visiting history
  useEffect(() => {
    if (currentStep === "view_history") {
      completeStep("view_history");
    }
  }, [currentStep, completeStep]);

  const handleSelectHistory = (item: SearchHistoryItem) => {
    // Navigate to search page with the selected history results
    navigate("/buscar", { 
      state: { 
        searchResults: Array.isArray(item.results) ? item.results : [],
        fromHistory: true 
      } 
    });
  };

  const handleBackToSearch = () => {
    navigate("/buscar");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading DoctIA...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    navigate(`/auth?returnTo=${encodeURIComponent(window.location.pathname)}`);
    return null;
  }

  return (
    <>
      <Helmet>
        <title>DoctIA | Historial</title>
        <meta name="description" content="Revisa tu historial de búsquedas en DoctIA y accede fácilmente a resultados anteriores." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        
        <div className="container max-w-4xl mx-auto px-6 py-8">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <div className="flex justify-between items-center mb-6">
              <TabsList className="grid w-fit grid-cols-2">
                <TabsTrigger value="searches">Búsquedas</TabsTrigger>
                <TabsTrigger value="summaries">Resúmenes</TabsTrigger>
              </TabsList>
            </div>
            
            <TabsContent value="searches">
              <SearchHistory 
                onBack={handleBackToSearch}
                onSelectHistory={handleSelectHistory}
              />
            </TabsContent>
            
            <TabsContent value="summaries">
              <SummaryHistory onBack={handleBackToSearch} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default Historial;